<template>
  <div class="ds-control ds-sms-vcrontab">
    <vcrontab v-if="ready" ref="cron" @hide="hide" :expression="cronExpression"></vcrontab>
  </div>
</template>

<script>
import { loadVcrontab } from "_platform/output/loadLibScript";

export default dsf.component({
  name: "DsfRepeatSendSetting",
  ctrlCaption: "重复发送时间设置",
  mixins: [$mixins.control],
  props: {
    cronExpression: {
      type: String,
      default: "",
    },
    parent: {
      type: Object,
      default: () => {
        return {};
      },
    },
    setCornExpression: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      ready: false
    };
  },
  created() {
    loadVcrontab(() => {
      this.ready = true;
    });
  },
  methods: {
    yes() {
      return this.$refs.cron.contabValueString;
    },
    onChangeCron(cron) {
      // console.log("onChangeCron", cron);
    },

    hide() {
      this.$dialog.close();
    },
    clearCron(val) {
      this.$refs.cron.clearCron();
    },
  },
});
</script>
